import React from 'react'

import SeletorCliente from 'entity/Cliente/components/SeletorCliente'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import SelectInput from 'components/form/input/SelectInput'
import FormRow from 'components/form/FormRow'
import Operador from 'entity/Operador'


function OperadorFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <FormRow>
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="sequencialIndex"
                    label="Código"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                    disabled
                />
                <SelectInput
                    sx={{ flex: 0.5 }}
                    name="status"
                    label="Status"
                    options={["ATIVO", "INATIVO"]}
                    required
                />
            </FormRow>

            <FormRow>
                <SeletorCliente
                    sx={{ flex: 1 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
                <TextInput
                    sx={{ flex: 1 }}
                    name="operador"
                    label="Operador"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
            </FormRow>
        </FormContent>
    )
}

export default function OperadorForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Operador"}
            EntityClass={Operador}
            routeForm={"_operador"}
            backRoute="consulta-operador"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <OperadorFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
